export interface UpdateNoticeRequest {
  id: string
  displayTarget: NoticeTargetBranch
  displayBranchCode: string
  displayPlaceCode: string
  displayStartDate: string
  displayEndDate: string
  body: string
  revision: number
}

export const NoticeTargetBranch = {
  All: '0', // 全館
  Specification: '1', // 指定館
  Place: '2' // 処理場所
}
export type NoticeTargetBranch = typeof NoticeTargetBranch[keyof typeof NoticeTargetBranch]

export function UpdateNoticeRequestToJSON(value: UpdateNoticeRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    display_target:
      value.displayTarget !== '' ? value.displayTarget : undefined,
    display_branch_code:
      value.displayBranchCode !== '' ? value.displayBranchCode : undefined,
    display_place_code:
      value.displayPlaceCode !== '' ? value.displayPlaceCode : undefined,
    display_start_date:
      value.displayStartDate !== '' ? value.displayStartDate : undefined,
    display_end_date:
      value.displayEndDate !== '' ? value.displayEndDate : undefined,
    body: value.body !== '' ? value.body : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
